import * as React from "react";
import { EventCardSectionItem } from "../../EventCardSectionItem";
export var renderDateAndTime = function (startDate, startTime) {
    return React.createElement(React.Fragment, null,
        React.createElement(EventCardSectionItem, { content: startDate, className: "rj-ev-list__ev-card__date" }),
        React.createElement(EventCardSectionItem, { content: startTime, className: "rj-ev-list__ev-card__time" }));
};
//# sourceMappingURL=renderDateAndTime.js.map